<template>
  <div class="graph">
    <div class="graph__axis">
      <div class="graph__axis__years">
        <div
          class="graph__axis__years__year"
          v-for="(year, index) in chart.years"
          :key="'year' + index"
          :style="{
            'border-bottom': `1px solid hsla(0, 0%, 96%, calc(1 - ${index} / 10))`,
          }"
        >
          {{ year }}
        </div>
      </div>
    </div>

    <div
      :class="['graph__container', { mouseDown: mouseDown }]"
      id="container"
      @mousedown="mouseDown = true"
      @mouseup="mouseDown = false"
    >
      <div class="graph__container__grid" id="grid">
        <div
          :class="[
            'graph__container__grid__area',
            { notSelected: selectedAreaId != area.id && selectedAreaId },
          ]"
          :id="area.id"
          v-for="area of chart.areas"
          :key="area.id"
        >
          <DataMilestones
            id="dataMilestone"
            v-for="(step, stepIndex) of area.steps"
            :key="area.id + stepIndex"
            :area="step"
            :years="chart.years"
          />
        </div>
        <div class="graph__container__grid__lines">
          <div
            class="graph__container__grid__lines__line"
            v-for="(year, index) in chart.years"
            :key="'year' + index"
            :style="{ opacity: 1 - index / 10 }"
          />
        </div>
      </div>

      <div class="graph__container__areas-index-container">
        <AreasIndex
          :class="{ notSelected: selectedAreaId != area.id && selectedAreaId }"
          v-for="(area, index) in chart.areas"
          :key="area.id"
          :isLastOne="index == chart.areas.length - 1 ? true : false"
          :content="{ id: area.id, title: area.title }"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

import DataMilestones from "@/components/charts/info-road-2050/DataMilestones.vue";
import AreasIndex from "@/components/charts/info-road-2050/AreasIndex.vue";

defineProps({
  chart: {
    type: Object,
    required: true,
  },
  selectedAreaId: String,
});

const mouseDown = ref(false);
</script>

<style lang="scss" scoped>
.graph {
  height: 70.8%;
  margin-top: 2.5rem;
  position: relative;
  &__axis {
    height: 100%;
    width: 4.3rem;
    position: absolute;
    left: 0;
    z-index: 2;
    background: #27569e;
    text-align: center;
    &__years {
      height: 65%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &__year {
        @include p-m;
        color: #fffefa;
      }
    }
  }
  &__container {
    height: 100%;
    position: relative;
    overflow-x: auto;

    .desktop &,
    .large & {
      padding-right: 15rem;
    }

    &.mouseDown {
      cursor: grab;
    }
    &__grid {
      height: 65%;
      width: max-content;
      position: relative;
      display: flex;
      flex-direction: row;
      &__area {
        position: relative;
        left: 6.3rem;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
      }
      &__lines {
        position: absolute;
        top: 0;
        height: 100%;
        width: calc(100% + 11rem);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: -4rem;

        &__line {
          border-bottom: 1px solid var(--scala-grigi-gray-5);
          margin-top: 26px;
        }
      }
    }
    &__areas-index-container {
      display: flex;
      flex-direction: row;
      position: absolute;
      bottom: 4%;
      left: 5.4rem;
    }
  }
  &__container::-webkit-scrollbar {
    display: none;
  }
  .notSelected {
    opacity: 0.4;
  }
  .mobile & {
    margin-top: 1.8rem;
  }
}
</style>
